import React from "react";

export const ValanzLoader: React.FC = () => {
	return (
		<div className="loader-container">
			<img
				src={require("../assets/images/ValanzLoader.gif")}
				alt="Loading..."
				className="loader-image"
				width={200}
				height={200}
			/>
		</div>
	);
};
